import { Base } from './_base';

export class QueueBackend extends Base {
  constructor(item) {
    super(item);
  }
}
